import { DateTime, Interval } from "luxon";

export type Datelike = Date | DateTime | string;

export function toDateTime(input: Datelike): DateTime {
	if (DateTime.isDateTime(input)) {
		return input;
	}

	if (input instanceof Date) {
		return DateTime.fromJSDate(input);
	}

	const dateTime = DateTime.fromISO(input);

	if (!dateTime.isValid) {
		throw new Error(`Invalid ISO date string: "${input}"`);
	}

	return dateTime;
}

export function toPickerDate(input: Datelike | null | undefined): Date | null {
	if (input == null) {
		return null;
	}

	return toDateTime(input).toJSDate();
}

export function fromPickerDate(
	input: Date | null | undefined
): DateTime | null {
	if (!(input instanceof Date) || Number.isNaN(input.getTime())) {
		return null;
	}

	return DateTime.fromJSDate(input, { zone: "utc" });
}

export function toDateInterval(
	startTime: Datelike,
	endTime: Datelike
): Interval;

export function toDateInterval(object: {
	startTime: Datelike;
	endTime: Datelike;
}): Interval;

export function toDateInterval(array: [Datelike, Datelike]): Interval;

export function toDateInterval(arg1: any, arg2?: any) {
	if (Array.isArray(arg1)) {
		return toDateInterval(arg1[0], arg1[1]);
	}

	if (typeof arg1 === "object") {
		return toDateInterval(arg1.startTime, arg1.endTime);
	}

	return Interval.fromDateTimes(toDateTime(arg1), toDateTime(arg2));
}
